import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useDropzone } from 'react-dropzone';
import { v1 as uuid } from 'uuid';
import { Collapse } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ATTACHMENT_TYPES } from '../../../shared/utils/constants';

const Attacher = forwardRef(
  ({ t, onAcceptedFiles, acceptFiles, maxSize }, ref) => {
    const [notifier, setNotifier] = useState('');
    const { getRootProps, getInputProps, open, acceptedFiles, fileRejections } =
      useDropzone({
        noClick: true,
        noKeyboard: true,
        accept: acceptFiles,
        maxSize,
      });

    useImperativeHandle(ref, () => ({
      open,
    }));

    const onChange = (value) => {
      const filesToUpload = [...acceptedFiles];
      if (value) {
        filesToUpload.push(value);
      }
      const files = filesToUpload.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          id: uuid(),
          uploadType: file.type,
        })
      );
      onAcceptedFiles(files);
    };

    const rejectionNotifier = () => {
      if (fileRejections.length) {
        if (
          fileRejections[0].file.type
            .toUpperCase()
            .startsWith(ATTACHMENT_TYPES.AUDIO || ATTACHMENT_TYPES.VIDEO)
        ) {
          setNotifier(t('notifications.file-larger'));
          window.setTimeout(() => {
            setNotifier('');
          }, 5000);
        } else {
          onChange(fileRejections[0].file);
        }
      }
    };

    useEffect(() => {
      onChange();
    }, [acceptedFiles]);

    useEffect(() => {
      rejectionNotifier();
    }, [fileRejections]);

    return (
      <div className="attacher-wrapper">
        <Collapse in={!!notifier}>
          <div className="rejection-notifier">{notifier}</div>
        </Collapse>
        <div {...getRootProps({ className: 'attacher' })}>
          <input {...getInputProps()} />
        </div>
      </div>
    );
  }
);

Attacher.propTypes = {
  t: PropTypes.func.isRequired,
  onAcceptedFiles: PropTypes.func.isRequired,
  acceptFiles: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  maxSize: PropTypes.number,
};

Attacher.defaultProps = {
  acceptFiles: '',
  maxSize: 20048576,
};

export default memo(Attacher);
